.coreProctoringTimer {
	display: flex;
	position: relative;
	width: 180px;
	height: 180px;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	padding: 0.5rem;
	box-sizing: border-box;
}

.timerContainer {
	background: linear-gradient(135deg, rgba(250, 245, 255, 0.5) 0%, rgba(253, 242, 248, 0.5) 100%);
	box-shadow: 0px 5.54px 20.78px 0px #8b5cf61a;
	border-top: 0.69px solid #ffffff80;
	border-radius: 28px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	width: 90%;
	height: 90%;

	& .timerLabel {
		color: #5b5b5b;
		font-size: 0.75rem;
		line-height: 1.6;
		font-weight: 700;
	}
}

.timeCircle {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 70%;
	height: 70%;
	border-radius: 50%;
	background-color: #ffffff;

	border: 6px solid rgba(199, 108, 254, 0.2);
	box-shadow: 0px 0px 2px 0px rgba(131, 80, 244, 0.25);
	box-sizing: border-box;

	& .timeText {
		background:
			linear-gradient(135deg, #9810fa 0%, #e60076 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;

		font-weight: 700;
		font-size: 1rem;
		line-height: 1.4;
	}
}

/** Border inside border*/
.timeCircle::after {
	content: "";
	position: absolute;
	top: -3.5px;
	left: -3.5px;
	right: -3.5px;
	bottom: -3.5px;
	border-radius: 50%;
	border: 1px solid rgba(199, 108, 254, 0.6);
	pointer-events: none;
}

.iconContainer {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 29px;
	height: 29px;
	border-radius: 11px;
	background-color: #fff;
	position: absolute;
	flex-shrink: 0;

	& svg {
		flex-shrink: 0;
	}

	&.mic {
		box-shadow:
			0px 2.77px 4.16px -2.77px #fce7f380,
			0px 6.93px 10.39px -2.08px #fce7f380;
		border: 0.69px solid #fce7f3;
		top: 0;
		left: 0;

		& svg {
			color: #f6339a;
		}
	}

	&.camera {
		box-shadow:
			0px 2.77px 4.16px -2.77px #dbeafe80,
			0px 6.93px 10.39px -2.08px #dbeafe80;
		border: 0.69px solid #dbeafe;
		bottom: 0;
		right: 0;

		& svg {
			color: #2b7fff;
			width: 18px;
			height: 18px;
		}
	}

	&.webcam {
		box-shadow:
			0px 2.77px 4.16px -2.77px #f3e8ff80,
			0px 6.93px 10.39px -2.08px #f3e8ff80;
		border: 0.69px solid #f3e8ff;
		top: 8px;
		right: -8px;

		& svg {
			color: #ad46ff;
		}
	}

	&.computer {
		box-shadow:
			0px 2.77px 4.16px -2.77px #ffedd480,
			0px 6.93px 10.39px -2.08px #ffedd480;

		border: 0.69px solid #ffedd4;
		bottom: 8px;
		left: 0;

		& svg {
			color: #ff6900;
		}
	}
}
